import { Component, Input } from '@angular/core';
import { LeftPanelWidgetLibraryComponent } from '../left-panel-widget-library/left-panel-widget-library.component';

@Component({
  selector: 'app-widget-library',
  templateUrl: './widget-library.component.html',
  styleUrls: ['./widget-library.component.scss']
})


export class WidgetLibraryComponent {
  @Input() selectedSnapshotData: any | undefined;

  selectedSnapshotData1: any;

  ngOnInit() {
    this.selectedSnapshotData1 = this.selectedSnapshotData;
  }
}
